import React from "react";
import styles from "../CreateParameterPopup.module.css";
import LabelParameters from "../LabelParameters";
const Email = ({
  parameterData,
  handleChange,
  editingInput,
  setEditingInput,
}) => {
  return (
    <div>
      <LabelParameters
        value={parameterData.number}
        text={"email"}
        editingInput={editingInput}
        setEditingInput={setEditingInput}
      >
        <input
          type="text"
          value={parameterData?.email}
          name={"number"}
          onChange={handleChange}
          placeholder="@"
          className={styles.inputParameter}
        />
      </LabelParameters>
    </div>
  );
};

export default Email;
